import { render, staticRenderFns } from "./editxz.vue?vue&type=template&id=c0f7800a&scoped=true&"
import script from "./editxz.vue?vue&type=script&lang=js&"
export * from "./editxz.vue?vue&type=script&lang=js&"
import style0 from "./editxz.vue?vue&type=style&index=0&id=c0f7800a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f7800a",
  null
  
)

export default component.exports